import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { IMG } from "../lib/api";

const TEAM = [
  { name: "Dr. Francisco Pina Ramón", role: "Director · Fundador 1984", img: IMG.doctors.pinaRamon },
  { name: "Dr. Francisco Pina Adell", role: "Implantología y prótesis", img: IMG.doctors.pinaAdell },
  { name: "Dr. Pablo Pina Adell", role: "Cirugía y endodoncia", img: IMG.doctors.pabloPina },
  { name: "Dra. Iris Ladrón de Guevara", role: "Ortodoncia y odontopediatría", img: IMG.doctors.iris },
];

export default function TeamSection() {
  return (
    <section className="py-24 bg-white" data-testid="team-section">
      <div className="container-max">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          {/* Content */}
          <div className="lg:col-span-5">
            <div className="inline-flex items-center gap-2 bg-teal-50 rounded-full px-4 py-1.5 mb-5">
              <span className="text-xs font-semibold text-teal-700 uppercase tracking-wider">Nuestro equipo</span>
            </div>
            <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-6 leading-tight">
              Doctores que te <span className="underline-accent">conocen por tu nombre</span>
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              Tres generaciones de la familia Pina cuidando sonrisas en Calafell. Junto a la Dra. Ladrón de Guevara,
              formamos un equipo multidisciplinar que ha tratado a miles de familias en estas cuatro décadas.
            </p>

            <div className="bg-teal-50 rounded-3xl p-6 mb-6 border border-teal-100">
              <div className="text-5xl font-bold text-teal-700 leading-none">40+</div>
              <div className="text-slate-700 mt-2 font-medium">años cuidando sonrisas en Calafell Platja</div>
            </div>

            <Link
              to="/equipo"
              data-testid="team-learn-more"
              className="inline-flex items-center gap-2 text-teal-700 hover:text-teal-900 font-semibold text-sm group"
            >
              Conoce a todo el equipo
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>

          {/* Team grid */}
          <div className="lg:col-span-7 grid grid-cols-2 gap-4">
            {TEAM.map((m, i) => (
              <motion.div
                key={m.name}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
                className="rounded-3xl overflow-hidden border border-slate-200 bg-white hover:shadow-lg transition-shadow group"
                data-testid={`team-mini-${i}`}
              >
                <div className="aspect-[4/5] overflow-hidden bg-slate-100">
                  <img
                    src={m.img}
                    alt={m.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-4">
                  <h3 className="font-bold text-slate-900 text-sm leading-tight mb-1">{m.name}</h3>
                  <p className="text-xs text-teal-700 font-medium">{m.role}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
